import React, { useState } from 'react';

/**
 * TopBar — minimal command-line header.
 *   ~ dashboard $ _                                    [+ New ▾]
 *
 * Search is visual-only in v1 (it's the affordance for the future ⌘K
 * command palette). The "New" dropdown provides keyboard-accessible
 * quick actions.
 */
const TopBar: React.FC = () => {
  const [newOpen, setNewOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  return (
    <div className="home-topbar">
      <div className="home-topbar__prompt">
        <span className="home-topbar__host">~</span>
        <span className="home-topbar__path">dashboard</span>
        <span className="home-topbar__sigil">$</span>
        <input
          className="home-topbar__search"
          type="text"
          placeholder="search anything (coming soon)"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          aria-label="Search"
          disabled
        />
        <span className="home-topbar__cursor" aria-hidden="true">_</span>
      </div>

      <div className="home-topbar__actions">
        <button
          type="button"
          className="home-btn home-btn--primary"
          onClick={() => setNewOpen(!newOpen)}
          aria-expanded={newOpen}
        >
          [+ new {newOpen ? '▴' : '▾'}]
        </button>
        {newOpen && (
          <div className="home-topbar__new-menu" role="menu">
            <button
              className="home-topbar__new-item"
              role="menuitem"
              onClick={() => { setNewOpen(false); window.location.href = '/jobtracking/summary'; }}
            >
              <span className="home-kbd">j</span> new job
            </button>
            <button
              className="home-topbar__new-item"
              role="menuitem"
              onClick={() => { setNewOpen(false); window.location.href = '/accounting'; }}
            >
              <span className="home-kbd">i</span> new invoice
            </button>
            <button
              className="home-topbar__new-item"
              role="menuitem"
              onClick={() => { setNewOpen(false); window.location.href = '/contacts'; }}
            >
              <span className="home-kbd">c</span> new contact
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopBar;
